import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { GetUsersRequest, UserRequest } from './interfaces/user.request';
import { UserResult } from './interfaces/user.result';
import { UserInteractor } from '../interactor/user.interactor';
import { User } from '../../../../models/user.model';
import { IsRequestComplete } from '../../../../interfaces/isrequest-complete';



@Injectable({
  providedIn: 'root'
})
export class UserPresenter implements UserResult, IsRequestComplete, UserRequest, GetUsersRequest {

private userResult: UserResult;
private _isRequestComplete: IsRequestComplete;

constructor(private interactor: UserInteractor){
  interactor.setPresenter(this);
}

setRequestCompleteComponent(isRequestComplete: IsRequestComplete){
  this._isRequestComplete = isRequestComplete;
}
setComponent(result: UserResult){
  this.userResult = result;
}

isRequestComplete(status: boolean, error?: HttpErrorResponse, data?: object): void {
  this._isRequestComplete.isRequestComplete(status, error, data);
}

getResponse(response: HttpResponse<any>): void {
  this.userResult.getResponse(response);
}


getUsers(): Promise<User[]> {
    return this.interactor.getUsers();
}

editUser(user: User): void {
    this.interactor.editUser(user);
}

deleteUser(id: string): void {
  this.interactor.deleteUser(id);
}

getUid(): string {
  return this.interactor.getuid;
}

}
